module.exports = __webpack_public_path__ + "img/addWhite.76227b1e.svg";